<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title [text]="'dashboard_ui.w_nc_closure_metrics' | trans" [accent]="tauxClotureLabel()" [widget]="widget()" [draggable]="true">
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>
    @if (showPeriodFilter()) {
      <vl-widget-period-filters
        [(timeScale)]="timeScale"
        [showPeriod]="false"
        [showComparison]="false"/>
    }
  </vl-widget-title>

  @if (isLoading() && !displayData()) {
    <div class="flex-col gap-12 widget-content">
      <ngx-skeleton-loader count="3" [theme]="{'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else if (hasData()) {
    <div class="flex-col w100 widget-content fade-in" style="overflow: hidden; gap: 12px">
      <!-- KPI row -->
      <div class="flex-row gap-8">
        <div class="kpi-mini grow">
          <span class="caption-2 on-background-alt">{{ 'dashboard_ui.nc_kpi_taux_cloture' | trans }}</span>
          <span class="subheading-1">{{ tauxClotureLabel() }}</span>
        </div>
        <div class="kpi-mini grow">
          <span class="caption-2 on-background-alt">{{ 'dashboard_ui.nc_kpi_delai_moyen' | trans }}</span>
          <span class="subheading-1">{{ delaiMoyenLabel() }}</span>
        </div>
        <div class="kpi-mini grow" [matTooltip]="'dashboard_ui.nc_kpi_sla_j30_hint' | trans">
          <span class="caption-2 on-background-alt">{{ 'dashboard_ui.nc_kpi_sla_j30' | trans }}</span>
          <span class="subheading-1">{{ slaJ30Label() }}</span>
        </div>
      </div>

      <!-- Timeline chart -->
      <div class="grow" style="position: relative; min-height: 0">
        <canvas #timelineChart></canvas>
      </div>

      <!-- Footer -->
      <div class="flex-row align-center gap-8" style="justify-content: space-between">
        <span class="caption on-background-alt">{{ displayData()?.cloturees ?? 0 }} / {{ displayData()?.total ?? 0 }} clôturées</span>
        <vl-chips state="active" size="small" iconRight="open_in_new" (action)="openFullList()">
          {{ 'button.see_all' | trans }}
        </vl-chips>
      </div>
    </div>
  } @else {
    <span class="caption on-disabled">{{ 'list.empty' | trans }}</span>
  }
</div>
